import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

/**
 * Navigation that works like SectionPicker (value / onChange over a list of
 * options) but lays the options out vertically with an icon next to each one.
 *
 * Options are `{ label, value, icon }` where `icon` is a component (e.g. a
 * heroicon) that will be rendered to the left of the label.
 *
 * The `sidebar` variant is the left hand navigation used on larger screens, the
 * `list` variant is the full width list used on mobile.
 */
const SideNavPicker = ({
    options,
    value,
    onChange,
    className = '',
    variant = 'sidebar',
}) => {
    if (variant === 'list') {
        return (
            <div className={`panel max-w-none pl-4 ${className}`}>
                {options.map((opt, idx) => (
                    <button
                        key={opt.value}
                        type="button"
                        className="w-full flex items-center pr-4 text-left"
                        onClick={() => onChange(opt.value)}
                    >
                        {!!opt.icon && (
                            <opt.icon className="w-6 h-6 mr-3 shrink-0 text-primary-700" />
                        )}
                        <div
                            className={`flex-1 flex items-center justify-between py-3 ${idx !== 0 ? 'border-t' : ''}`}
                        >
                            <span>{opt.label}</span>
                            <ChevronRightIcon className="w-5 h-5 shrink-0 text-gray-500" />
                        </div>
                    </button>
                ))}
            </div>
        );
    }

    return (
        <div className={className}>
            {options.map(opt => (
                <button
                    key={opt.value}
                    type="button"
                    className={`w-full flex items-center px-3 py-2 mb-1 rounded-md text-left ${
                        opt.value === value
                            ? 'bg-gray-200 text-primary-700'
                            : 'text-gray-500 hover:bg-gray-200/50'
                    }`}
                    onClick={() => onChange(opt.value)}
                >
                    {!!opt.icon && (
                        <opt.icon className="w-5 h-5 mr-3 shrink-0" />
                    )}
                    <span>{opt.label}</span>
                </button>
            ))}
        </div>
    );
};

export default SideNavPicker;
